<template>
	<div>
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><router-link to="/workflows">Utasítások</router-link></li>
			<li class="breadcrumb-item active">{{workflow.name}}</li>
		</ol>
		<h1 class="page-header">Utasítás szerkesztése</h1>
		<Loading v-if="workflow === false" title="Szekrény betöltése"></Loading>
		<NoRecords v-else-if="workflow.notfound" main_icon="fas fa-user-lock" value="false" title="Nem található a szekrény" subtitle="Menjen vissza a csoport lakat szekrényekhez!"></NoRecords>
		<panel v-else title="Adatok">
			<form @submit.prevent="updateWorkflow">
				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label class="form-label">Megnevezés:</label>
							<input type="text" class="form-control" v-model="workflow.name">
						</div>
					</div>
				</div>
				<div class="row my-2">
					<div class="form-group">
						<label class="form-label">Leírás:</label>
						<textarea cols="30" rows="10" v-model="workflow.description" class="form-control"></textarea>
					</div>
				</div>
				<button class="btn btn-success"><i class="fa fa-save"></i> Mentés</button>
			</form>
		</panel>
	</div>
</template>

<script>
	import Loading from '../../components/Loading';
	import NoRecords from '../../components/NoRecords';
	import Workflow from "../../apis/Workflow";

	export default {
		components: {
			Loading, NoRecords
		},
		data() {
			return {
				workflow:false,
				errors: [],
			}
		},
		created() {
			
			Workflow.show(this.$route.params.id)
			.then(response => {
				this.workflow = response.data
			}).catch(() => {
				this.$set(this,'workflow',{name:'ismeretlen', notfound:true});
			});
		},
		methods: {
			updateWorkflow(){
				Workflow.update(this.$route.params.id,this.workflow)
				.then(() => {
					console.log('siker');
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			}
		},
	}
</script>

<style>
	
</style>